import React from "react";
import "../App.css";

export default function Cookie() {
  return (
    <>
      <section className="privacy-hero">
        <div className="container">
          <h1>
            COOKIE <span>POLICY</span>
          </h1>

          <p className="privacy-company">
            Selenean Technologies Private Limited
          </p>

          <div className="privacy-meta">
            <span>Effective date: 13 August 2026</span>
            <span className="privacy-meta-divider">|</span>
            <span>Last updated: 13 August 2026</span>
          </div>
        </div>
      </section>

      <section className="privacy-page">
        <div className="container">
          <p className="privacy-intro">
            This Cookie Policy explains how Selenean Technologies Private
            Limited (CIN: U26100KA2024PTC194103) ("Selenean", "Company", "we",
            "us" or "our”) uses cookies and similar tracking technologies on our
            website, what they are, why we use them, and how you can control
            them. This Policy should be read together with our Privacy Policy
            and Terms of Use.
          </p>

          <article className="privacy-body">
            <section id="what-are-cookies" className="privacy-section">
              <h2>
                <span className="privacy-num">1.</span>WHAT ARE COOKIES
              </h2>

              <p>
                Cookies are small text files placed on your computer, smartphone
                or other device when you visit a website. They help websites
                operate efficiently, improve the browsing experience, and provide
                reporting information to site operators. Selenean also uses
                similar technologies, including web beacons, pixel tags and local
                storage, which this Policy refers to collectively as "cookies"
                unless the context requires otherwise.
              </p>
            </section>

            <section id="types" className="privacy-section">
              <h2>
                <span className="privacy-num">2.</span>TYPES OF COOKIES WE USE
              </h2>

              <p>
                2.1. We categorise the cookies used on our website as follows:
              </p>

              <ul className="privacy-list">
                <li>
                  <span className="privacy-letter">(a)</span>
                  <span>
                    <strong>Essential Cookies:</strong> strictly necessary for
                    the website to function, such as those enabling log-in, form
                    submission, or saved privacy preferences. These cannot be
                    switched off, and, consistent with applicable law, do not
                    require your consent.
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(b)</span>
                  <span>
                    <strong>Performance Cookies:</strong> collect anonymised
                    information about how visitors use our website, such as which
                    pages are visited most and whether errors occur, to help us
                    improve performance and usability. These cookies do not
                    identify you personally.
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(c)</span>
                  <span>
                    <strong>Functional Cookies:</strong> enable enhanced
                    functionality and personalisation, such as remembering your
                    language, region or display preferences. They may be set by
                    us or by third-party providers integrated into our pages.
                  </span>
                </li>
              </ul>
            </section>

            <section id="legal-basis" className="privacy-section">
              <h2>
                <span className="privacy-num">3.</span>LEGAL BASIS AND CONSENT
                FOR NON-ESSENTIAL COOKIES
              </h2>

              <p>
                We deploy these cookies only with your consent, obtained through
                our cookie consent banner or preference centre, and that consent
                is free, specific, informed and given through a clear affirmative
                action. You may withdraw consent at any time, as easily as you
                gave it, by adjusting your preferences in our consent banner or
                your browser settings, without affecting the lawfulness of
                processing carried out before withdrawal.
              </p>
            </section>

            <section id="manage" className="privacy-section">
              <h2>
                <span className="privacy-num">4.</span>HOW TO MANAGE COOKIES
              </h2>

              <p>
                4.1. You may accept or reject non-essential cookies at any time
                through our on-site cookie preference centre, or through your
                browser settings.
              </p>

              <p>
                4.2. Disabling or blocking cookies may affect the functionality
                of our website. Essential Cookies described in Clause 2 (Types of
                Cookies We Use) cannot be disabled, as they are required for the
                site to function. Deleting all cookies will also remove your
                saved preferences, including any opt-out preference, since that
                preference itself is stored in a cookie.
              </p>
            </section>

            <section id="third-party" className="privacy-section">
              <h2>
                <span className="privacy-num">5.</span>THIRD-PARTY COOKIES
              </h2>

              <p>
                5.1. Selenean permits certain trusted third parties to place
                cookies on your device through our website, for the following
                purposes:
              </p>

              <ul className="privacy-list">
                <li>
                  <span className="privacy-letter">(a)</span>
                  <span>
                    Analytics services, to help us understand how visitors use
                    our website, including page views and navigation paths;
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(b)</span>
                  <span>
                    Social media integrations, such as share buttons or embedded
                    feeds, which may set cookies to enable functionality and
                    track interactions; and
                  </span>
                </li>
                <li>
                  <span className="privacy-letter">(c)</span>
                  <span>
                    Content delivery networks, which may set cookies for load
                    balancing and performance.
                  </span>
                </li>
              </ul>

              <p>
                5.2. Selenean does not control cookies placed by third parties.
                We recommend reviewing the privacy and cookie policies of these
                third parties for further information on how they use data.
              </p>
            </section>

            <section id="updates" className="privacy-section">
              <h2>
                <span className="privacy-num">6.</span>UPDATES TO THIS POLICY
              </h2>

              <p>
                We may update this Policy to reflect changes in the cookies we
                use, changes in technology, or for operational, legal or
                regulatory reasons. When we make changes, we will revise the
                "Last updated" date above. We encourage you to review this Policy
                periodically.
              </p>
            </section>

            <section id="contact" className="privacy-section">
              <h2>
                <span className="privacy-num">7.</span>CONTACT US
              </h2>

              <p>
                7.1. If you have questions, concerns or requests regarding this
                Cookie Policy or our data practices, please contact us, you may
                visit our Contact Page and submit your questions, concerns or
                requests, as the case may be.
              </p>

              <p>
                7.2. This Cookie Policy should be read together with our Privacy
                Policy and Terms of Use, which provide further information on how
                Selenean handles your data.
              </p>
            </section>
          </article>
        </div>
      </section>
    </>
  );
}
